import { motion } from "framer-motion";
import {
    Award,
    Building2,
    HeartPulse,
    Fan,
    ShoppingBasket,
    Leaf,
} from "lucide-react";
import { BRAND_EXPERIENCE } from "@/lib/constants";

const ICONS = { Building2, HeartPulse, Fan, ShoppingBasket, Leaf };

export default function Brands() {
    return (
        <section
            id="brands"
            data-testid="brands-section"
            className="relative py-24 md:py-32 bg-white"
        >
            <div className="max-w-7xl mx-auto px-6 md:px-10">
                <div className="max-w-3xl">
                    <div className="inline-flex items-center gap-2 text-ae-orange text-xs font-bold uppercase tracking-[0.22em]">
                        <Award className="h-4 w-4" /> Selected Brand Experience
                    </div>
                    <h2 className="mt-5 font-display font-extrabold text-4xl md:text-5xl lg:text-6xl text-ae-ink tracking-tight leading-[1.02]">
                        Trusted across categories.
                    </h2>
                    <p className="mt-5 text-base md:text-lg text-ae-gray-700">
                        A snapshot of the brands and industries we&apos;ve helped amplify —
                        from FMCG and real estate to healthcare, HVAC and renewable
                        energy.
                    </p>
                </div>

                <div
                    className="mt-14 rounded-3xl border border-black/5 bg-ae-gray-100/60 overflow-hidden divide-y divide-black/5"
                    data-testid="brands-table"
                >
                    {BRAND_EXPERIENCE.map((row, i) => {
                        const Icon = ICONS[row.icon];
                        return (
                            <motion.div
                                key={row.industry}
                                initial={{ opacity: 0, y: 16 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: true, margin: "-40px" }}
                                transition={{ duration: 0.6, delay: i * 0.06 }}
                                data-testid={`brands-row-${row.industry.toLowerCase().replace(/\s+/g, "-")}`}
                                className="group grid grid-cols-1 md:grid-cols-12 gap-3 md:gap-8 px-6 md:px-8 py-6 md:py-7 hover:bg-white transition-colors"
                            >
                                <div className="md:col-span-3 flex items-center gap-3">
                                    <div className="h-10 w-10 rounded-xl bg-ae-orange/10 text-ae-orange flex items-center justify-center group-hover:bg-ae-orange group-hover:text-white transition-colors">
                                        {Icon ? <Icon className="h-5 w-5" /> : null}
                                    </div>
                                    <div className="font-display font-bold text-ae-orange tracking-tight text-lg">
                                        {row.industry}
                                    </div>
                                </div>
                                <div className="md:col-span-9 text-ae-ink text-sm md:text-base leading-relaxed">
                                    {row.clients.map((c, idx) => (
                                        <span key={c}>
                                            <span className="font-medium">{c}</span>
                                            {idx !== row.clients.length - 1 && (
                                                <span className="text-ae-gray-500">
                                                    {" · "}
                                                </span>
                                            )}
                                        </span>
                                    ))}
                                </div>
                            </motion.div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
}
